module.exports = __webpack_public_path__ + "assets/media/3.6fa768d7.wav";